import { render } from "./product-prices.vue?vue&type=template&id=3042a1a2"
import script from "./product-prices.vue?vue&type=script&lang=js"
export * from "./product-prices.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/bio-effect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__